import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle, MessageCircle, Phone, MapPin, Clock } from "lucide-react";
import {
  getWhatsAppUrl, PHONE_PRIMARY, PHONE_PRIMARY_TEL, CLINIC_ADDRESS,
  CLINIC_TIMINGS, GOOGLE_MAPS_DIRECTIONS,
} from "@/lib/constants";
import { track, trackCall, trackWhatsApp, trackDirections } from "@/lib/analytics";

const ThankYou = () => {
  useEffect(() => { track("thank_you_page_view"); }, []);

  return (
    <div className="min-h-[60vh] flex items-center justify-center py-16">
      <div className="container max-w-lg text-center">
        <div className="h-16 w-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="h-8 w-8 text-primary" />
        </div>
        <h1 className="font-heading text-3xl font-bold mb-3">Thank You!</h1>
        <p className="text-muted-foreground mb-6">
          Our team will call or WhatsApp you shortly to confirm your appointment at Mutha's Advanced Dental Care, Kalyan.
        </p>
        <div className="space-y-3">
          <Button asChild className="w-full h-12">
            <a
              href={getWhatsAppUrl("Hi, I just submitted an appointment request. Can you confirm my slot?")}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackWhatsApp("thank_you")}
            >
              <MessageCircle className="h-5 w-5 mr-2" /> WhatsApp Us
            </a>
          </Button>
          <Button asChild variant="outline" className="w-full h-12">
            <a href={PHONE_PRIMARY_TEL} onClick={() => trackCall("thank_you")}>
              <Phone className="h-5 w-5 mr-2" /> Call {PHONE_PRIMARY}
            </a>
          </Button>
        </div>

        <div className="mt-8 rounded-xl border border-border bg-accent/40 p-5 text-left text-sm">
          <a
            href={GOOGLE_MAPS_DIRECTIONS}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackDirections("thank_you")}
            className="flex items-start gap-2 text-primary hover:underline"
          >
            <MapPin className="h-4 w-4 mt-0.5 shrink-0" /> {CLINIC_ADDRESS}
          </a>
          <div className="mt-3 flex items-start gap-2 text-muted-foreground">
            <Clock className="h-4 w-4 mt-0.5 shrink-0 text-primary" />
            <span>
              Mon–Sat: {CLINIC_TIMINGS.weekdays}<br />
              Sunday: {CLINIC_TIMINGS.sunday}
            </span>
          </div>
        </div>

        <Button asChild variant="ghost" className="w-full mt-6">
          <Link to="/">Back to Home</Link>
        </Button>
      </div>
    </div>
  );
};

export default ThankYou;
